import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: theme.palette.primary.A100,
  },
  segment: {
    height: '100%',
    transition: theme.transitions.create(['flex-basis', 'background-color'], {
      duration: theme.transitions.duration.short,
    }),
  },
});

const MultiSegmentProgressBar = ({
  segments,
  height,
  gap,
  borderRadius,
  className,
  classes,
}) => {
  const total = segments.reduce((sum, item) => sum + (item.value || 0), 0);
  return (
    <div
      className={classNames(classes.root, className)}
      style={{
        height,
        borderRadius,
        gap,
      }}
    >
      {segments.map((segment, index) => {
        const width = total > 0 ? `${(segment.value / total) * 100}%` : '0%';
        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={classes.segment}
            style={{
              flexBasis: width,
              backgroundColor: segment.color,
              borderRadius,
            }}
          />
        );
      })}
    </div>
  );
};

MultiSegmentProgressBar.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
  })).isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    segment: PropTypes.string.isRequired,
  }).isRequired,
};

MultiSegmentProgressBar.defaultProps = {
  height: 4,
  gap: 0,
  borderRadius: 2,
  className: '',
};

export default withStyles(styles)(MultiSegmentProgressBar);



// WEBPACK FOOTER //
// ./src/components/common/MultiSegmentProgressBar.js